(function(root, factory) {
    if (typeof define === "function" && define.amd) {
        define([],
            function() {
                return (root.Datepicker = factory());
            });
    } else {
        root.Datepicker = factory();
    }
})(window, function() {
    "use strict";

    var Datepicker = function(parameters) {
        this.element = null;
        this.queryElement = parameters.queryElement;
        this.alertText = parameters.alertText;
    }

    Datepicker.prototype = {
        attachEventsToNotAvailableDay: function () {
            var anchorElements = document.querySelectorAll(".ui-datepicker-calendar a");
            for (var i = 0; i < anchorElements.length; i++) {
                anchorElements[i].removeAttribute("href");
            }

            this.element = document.querySelector(this.queryElement);
            if (this.element) {
                this.element.addEventListener("mouseenter", this.showNotAvailableDateAlert.bind(this));
                this.element.addEventListener("click", this.showNotAvailableDateAlert.bind(this));
                this.element.addEventListener("mouseleave", this.hiddenNotAvailableDateAlert.bind(this));
            }
        },

        drawNotAvailableDateAlert: function () {
            var alert;
            alert = document.createElement("p");
            alert.setAttribute("id", "alertNotAvailable");
            alert.innerText = this.alertText;
            alert.setAttribute("class", "tooltip__container");
            this.element.appendChild(alert);
            return alert;
        },

        showNotAvailableDateAlert: function () {
            var alert = document.getElementById("alertNotAvailable");
            if (!alert) {
                alert = this.drawNotAvailableDateAlert();
            }
            alert.style.display = "block";
        },

        hiddenNotAvailableDateAlert: function () {
            var alert = document.getElementById("alertNotAvailable");
            alert.style.display = "none";
        }
    }

    return Datepicker;
});